module.exports = __webpack_public_path__ + "static/media/lumpflakebreaker.7b3df5c5.png";